module.exports = __webpack_public_path__ + "img/icon-actividad.3d896e1e.svg";